import { getQuoteRequestLineProductLines } from "../helpers";
import { round } from "../utils";
import { computeProductsPrice } from "./computeProductsPrice";
import {
  QuoteRequestLineForComputing,
  QuoteRequestLinePrice,
} from "./computeQuoteRequestLinePrice";

type Params = {
  quoteRequestLine: QuoteRequestLineForComputing;
  isQuotePrice?: boolean;
};

export const computeConsummablePrice = ({
  quoteRequestLine,
  isQuotePrice,
}: Params): QuoteRequestLinePrice => {
  const { productsPrice, productsCost, productsMargin } = computeProductsPrice({
    productLines: getQuoteRequestLineProductLines(quoteRequestLine),
    productsMarginRatio: null,
    quantityInAssembly: null,
  });

  const partCost = isQuotePrice ? round(productsCost) : productsCost;
  const partPrice = isQuotePrice ? round(productsPrice) : productsPrice;
  const partMarginPrice = isQuotePrice ? round(productsMargin) : productsMargin;

  const seriesMultiplier = quoteRequestLine.quantity;

  const assembly = {
    addedValueProcessesCost: 0,
    productsProcessesCost: partCost,
    materialCost: 0,
    totalCost: partCost,
    totalMargin: partMarginPrice,
    totalPrice: partPrice,
  };

  const costs = {
    addedValueProcessesCost: 0,
    generalCost: 0,
    materialCost: 0,
    partAddedValueProcessesCost: 0,
    partMaterialCost: 0,
    partProductsProcessesCost: partCost,
    processesCost: partCost * seriesMultiplier,
    productsProcessesCost: partCost * seriesMultiplier,
  };

  const margins = {
    addedValueProcessesMargin: 0,
    generalMarginPrice: 0,
    materialMarginPrice: 0,
    partAddedValueProcessesMarginPrice: 0,
    partMaterialMarginPrice: 0,
    partProductsProcessesMarginPrice: partMarginPrice,
    processesMargin: partMarginPrice * seriesMultiplier,
    productsProcessesMargin: partMarginPrice * seriesMultiplier,
  };

  const prices = {
    addedValueProcessesPrice: 0,
    generalPrice: 0,
    materialPrice: 0,
    partAddedValueProcessesPrice: 0,
    partMaterialPrice: 0,
    partProductsProcessesPrice: partPrice,
    processesPrice: partPrice * seriesMultiplier,
    productsProcessesPrice: partPrice * seriesMultiplier,
  };

  return {
    partPrice,
    partCost,
    partMarginPrice,
    assembly,
    seriesPrice: partPrice * seriesMultiplier,
    seriesCost: partCost * seriesMultiplier,
    seriesMarginPrice: partMarginPrice * seriesMultiplier,
    costs,
    margins,
    prices,
    quantity: seriesMultiplier,
  };
};
